// Menuapiservice.js
import axios from "axios";
const BASE_URL =
    process.env.REACT_APP_API_URL;
const API_BASE_URL = process.env.REACT_APP_API_URL;

// ✅ Get vendorId and authToken once from localStorage
const vendorId = localStorage.getItem("vendorId");
const authToken = localStorage.getItem("authToken");

// ✅ Debug logs for missing values
if (!vendorId) console.warn("⚠️ vendorId is missing in localStorage");
if (!authToken) console.warn("⚠️ authToken is missing in localStorage");

// ✅ Common headers for both GET and POST
const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`,
};

/**
 * GET menu by vendor
 * Fetch all dishes for the vendor
 */
export const getMenuByVendor = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");
    // console.log("vendorId:", vendorId, "authToken:", authToken);

    if (!authToken) throw new Error("authToken is missing");

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
    };

    // Append vendorId if it exists  https://backend.maamaas.com/catering/api/dishes/getAll
    const url = vendorId
        ? `${API_BASE_URL}/api/admin/dishes/getAll?vendorId=${vendorId}`
        : `${API_BASE_URL}/api/user/dishes/getAll`;

    const response = await fetch(url, { headers });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    // console.log("🔹 GET Menu Data from API:", data);
    return data;
};



/**
 * POST a new dish
 * Add a new dish for the vendor
 * @param {Object} dishData - The body for the API
 * {
 *   "dishId": 0,
 *   "dishName": "string",
 *   "dishDescription": "string",
 *   "dishPrice": 0,
 *   "parentId": 0,
 *   "dishImage": "string",
 *   "discountPercentage": 0,
 *   "effectivePrice": 0,
 *   "available": true
 * }
 */
/**
 * POST a new dish using FormData (image as file)
 * @param {FormData} formData - FormData containing "image" file and "data" JSON string
 */
export const addNewDish = async (formData) => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) throw new Error("authToken is missing");

    try {
        // console.log("Adding new dish via FormData:", formData);

        const response = await fetch(`${API_BASE_URL}/api/admin/dishes`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`, // don't set Content-Type
            },
            body: formData, // send FormData
        });

        // console.log("Fetch called for POST new dish, Response status:", response.status);

        if (!response.ok) {
            const text = await response.text();
            console.error("POST API HTTP Error Text:", text);
            throw new Error(`POST error! Status: ${response.status}`);
        }

        const data = await response.json();
        // console.log("✅ New Dish Added:", data);
        return data;
    } catch (error) {
        console.error("Add Dish API Error:", error);
        throw error;
    }
};

export const uploadDish = async (
    formData,
    token
) => {
    try {

        const response = await axios.post(
            `${BASE_URL}/food/api/admin/dish/upload`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "UPLOAD Dish Error:",
            error
        );

        throw error;
    }
};

// ==============================
// GET DISH BY ID
// ==============================

export const getDishById = async (
    dishId,
    token
) => {
    try {

        const response = await axios.get(
            `${BASE_URL}/food/api/dish/${dishId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "GET Dish Error:",
            error
        );

        throw error;
    }
};

export const updateDish = async (
    dishId,
    formData,
    token
) => {
    try {

        const response = await axios.put(
            `${BASE_URL}/food/api/edit/dish/${dishId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "UPDATE Dish Error:",
            error
        );

        throw error;
    }
};

export const updateCategory = async (
    categoryId,
    formData,
    token
) => {
    try {

        const response = await axios.put(
            `${BASE_URL}/food/api/admin/category/${categoryId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "UPDATE Category Error:",
            error
        );

        throw error;
    }
};

export const deleteDish = async (
    dishId,
    token
) => {
    try {

        const response = await axios.delete(
            `${BASE_URL}/food/api/delete/dish/${dishId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "DELETE Dish Error:",
            error
        );

        throw error;
    }
};

export const deleteCategory = async (
    categoryId,
    token
) => {
    try {

        const response = await axios.delete(
            `${BASE_URL}/food/api/admin/category/${categoryId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "DELETE Category Error:",
            error
        );

        throw error;
    }
};